import { useState, useEffect } from 'react'

export const useGetMessagePostion = (userClickPosition, parentRef) => {
  const messageWidth = 220
  const [messagePos, setMessagePos] = useState({ left: 0, top: 0 })

  useEffect(() => {
    if (!parentRef?.current) return

    const parentRect = parentRef.current.getBoundingClientRect()
    const childRectRight = userClickPosition.x + messageWidth
    let childLeftPos = userClickPosition.x
    if (parentRect.right < childRectRight) {
      childLeftPos = parentRect.right - messageWidth
    }

    setMessagePos({ left: childLeftPos, top: userClickPosition.y })
  }, [parentRef, userClickPosition])

  return messagePos
}
